import React from 'react';
import moment from 'moment';

class Sales extends React.Component {
	render() {
		const { remaining_shares, remaining_days, settings, sold_shares } = this.props;

		return (
			<div>
				<div style={{ float: 'left', width: '100%' }}>
					<div className="student-chart">
						<div className="student-chart-content">
							<h4>{ remaining_shares } andelar<br />och { remaining_days } dagar<br />kvar till målet</h4>

							{ settings.start_date && moment().isBefore(settings.start_date) ? (
								<div className="button pink2 disabled auto-width">Ej påbörjad</div>
							) : (
								<div className="button pink2 auto-width" onClick={ () => this.props.parent.setState({ page: 'shares' }) }>Sälj andelar</div>
							) }
						</div>

						<svg className="circle-chart" viewBox="0 0 33.83098862 33.83098862" width="260" height="260" xmlns="http://www.w3.org/2000/svg">
							<defs>
								<linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
									<stop offset="0%" stopColor="#F74067" />
									<stop offset="100%" stopColor="#FA7942" />
								</linearGradient>
							</defs>

							<circle className="circle-chart__background" stroke="#49203F" strokeWidth="2" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431"/>
							<circle className="circle-chart__circle" stroke="url(#gradient)" strokeWidth="2" strokeDasharray="90,100" strokeLinecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431"/>
						</svg>
					</div>
				</div>

				<div style={{ textAlign: 'center' }}>
					Min försäljning: <span style={{ fontWeight: 'bold' }}>{ sold_shares ? sold_shares : '0' } andelar</span>
				</div>
			</div>
		)
	}
}
export default Sales;



// WEBPACK FOOTER //
// ./src/components/user/Dashboard/Home/Sales.js